import { BLOG_POSTS } from "../data/blogPosts";
import Breadcrumbs from "./Breadcrumbs";
import SectionHeading from "./SectionHeading";
import BlogPostCard from "./BlogPostCard";
import { useLanguage } from "../context/LanguageContext";

export default function BlogPage() {
  const { t } = useLanguage();

  return (
    <section className="bg-white pb-24 pt-24 md:pb-32 md:pt-32">
      <Breadcrumbs items={[{ label: t("blogPageTitle") }]} />
      <div className="container-industrial pt-16">
        <SectionHeading title={t("blogPageTitle")} description={t("blogPageDescription")} />

        <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {BLOG_POSTS.map((post) => (
            <BlogPostCard key={post.slug} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
}
